import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'quote-dialog',
    templateUrl: 'quote-dialog.component.html',
})
export class QuoteDialog {
    constructor(
        public dialogRef: MatDialogRef<QuoteDialog>,
        @Inject(MAT_DIALOG_DATA) public quote: string) {}
  
    onNoClick(): void {
        this.dialogRef.close();
    }
}